/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ e: NonNullable<unknown> }} Elec_ConsoInputs */



/**
* | output |
* | --- |
* | "Elec: {e} kWh" |
*
* @param {Elec_ConsoInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const elec_conso = /** @type {((inputs: Elec_ConsoInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elec_ConsoInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Elec: ${i?.e} kWh`)
	return /** @type {LocalizedString} */ (`Elec : ${i?.e} kWh`)
});